import React from 'react';
import '../../assets/css/spinner.css';

const Spinner = ({center}) => {
    return (
    <div className={`spinner ${center?"mx-auto":""}`}>
        <div className="rect1">&nbsp;</div>
        <div className="rect2">&nbsp;</div>
        <div className="rect3">&nbsp;</div>
        <div className="rect4">&nbsp;</div>
        <div className="rect5">&nbsp;</div>
     </div>
    )
}

export default Spinner
